/** Feedback sheet used by the shared page layout. */
export function feedbackWidget(messages) {
    return {
        isOpen: false,
        topic: '',
        message: '',
        sending: false,
        errorMsg: '',
        needsTopic: false,
        attachedFiles: [],

        get totalAttachments() {
            return this.attachedFiles.length;
        },

        get canAddMore() {
            return this.totalAttachments < 3;
        },

        init: function() {
            var self = this;
            window.addEventListener('open-feedback-widget', function() {
                self.topic = '';
                self.message = '';
                self.errorMsg = '';
                self.needsTopic = false;
                self.attachedFiles = [];
                self.isOpen = true;

                self.$nextTick(function() {
                    window.LucideIcons && window.LucideIcons.initialize(self.$el);
                });
            });
        },

        close: function() {
            this.isOpen = false;
            this.attachedFiles.forEach(function(f) {
                URL.revokeObjectURL(f.url);
            });
        },

        addFiles: function(event) {
            var input = event.target;
            if (!input.files) return;

            var maxSize = 5 * 1024 * 1024;
            var allowedTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/webp'];
            var self = this;
            self.errorMsg = '';

            Array.from(input.files).forEach(function(file) {
                if (!self.canAddMore) return;

                if (!allowedTypes.includes(file.type)) {
                    self.errorMsg = messages.invalidFileType;
                    return;
                }
                if (file.size > maxSize) {
                    self.errorMsg = messages.fileTooLarge;
                    return;
                }

                self.attachedFiles.push({
                    file: file,
                    url: URL.createObjectURL(file)
                });
            });

            // Reset the input so the same file can be selected again
            input.value = '';
        },

        removeFile: function(index) {
            var removed = this.attachedFiles.splice(index, 1);
            if (removed.length > 0) {
                URL.revokeObjectURL(removed[0].url);
            }
        },

        submit: function() {
            if (this.sending) return;
            if (!this.topic) {
                this.needsTopic = false;
                var self = this;
                requestAnimationFrame(function() { self.needsTopic = true; });
                return;
            }
            if (!this.message.trim()) return;

            var self = this;
            self.sending = true;
            self.errorMsg = '';

            var csrfMeta = document.querySelector('meta[name="csrf_token"]');
            var csrfToken = csrfMeta ? csrfMeta.getAttribute('content') : '';

            var formData = new FormData();
            formData.append('topic', self.topic);
            formData.append('message', self.message.trim());
            formData.append('page_url', window.location.href);
            formData.append('csrf_token', csrfToken);

            self.attachedFiles.forEach(function(item) {
                formData.append('attachments[]', item.file, item.file.name);
            });

            fetch('/app/feedback/submit', {
                method: 'POST',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                    'X-Screen-Width': String(window.screen.width),
                    'X-Screen-Height': String(window.screen.height),
                    'X-Viewport-Width': String(window.innerWidth),
                    'X-Viewport-Height': String(window.innerHeight)
                },
                body: formData
            })
            .then(function(res) { return res.json(); })
            .then(function(data) {
                self.sending = false;
                if (data.success) {
                    self.close();
                    if (window.showSuccess) {
                        window.showSuccess(messages.success);
                    }
                } else {
                    self.errorMsg = data.error || messages.error;
                }
            })
            .catch(function() {
                self.sending = false;
                self.errorMsg = messages.error;
            });
        }
    };
}
